import { ChatBubbleOvalLeftEllipsisIcon } from '@heroicons/react/24/outline'
import { useRecoilState, useRecoilValue } from 'recoil'
import { ContentView } from '../../../api/client'
import { openConversationContentIdState } from '../../../store/ConversationStore'
import { conversationViewEnabledState } from '../../../store/DomainStore'
import BaseActionButton from './BaseActionButton'

type Props = { content: ContentView }

/**
 * Opens the conversation drawer for this comment. Always present,
 * including on top-level comments, so the thread is never hidden behind the
 * reply modal. Highlighted while the drawer is open for this comment. Hidden
 * for users without the conversation_view_enabled rollout toggle.
 */
export default function ViewConversationButton({ content }: Props) {
    const enabled = useRecoilValue(conversationViewEnabledState)
    const [openId, setOpenId] = useRecoilState(openConversationContentIdState)
    if (!enabled) {
        return null
    }
    return (
        <BaseActionButton
            tooltip="View conversation"
            loading={false}
            colour="blue"
            actionAlreadyApplied={openId === content.id}
            isActionQueued={false}
            icon={<ChatBubbleOvalLeftEllipsisIcon className="h-6 w-6" aria-hidden="true" />}
            onActionClick={() => setOpenId(openId === content.id ? null : content.id)}
        />
    )
}
